import {ReactComponent as Check} from '../../../assets/svg/passwordCheck.svg';
import {ReactComponent as Cross} from '../../../assets/svg/passwordCross.svg';
import i18n from '../../../i18n';

import {Form, Button, Spinner} from '@deere/ux.uxframe-react';
import React, {useState} from 'react';
import './password.css';

const VerifyPassword = (props) => {
  const initialValue = {
    lowerCaseChecked: false,
    upperCaseChecked: false,
    specialCharChecked: false,
    numberChecked: false,
    lengthChecked: false,
  };

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordVerification, setPasswordVerification] =
    useState(initialValue);
  const [passwordMismatch, setPasswordMismatch] = useState(false);

  const handleNewPassword = (value) => {
    const lowerCase = /^(?=.*[a-z])/;
    const upperCase = /^(?=.*[A-Z])/;
    const number = /^(?=.*[0-9])/;
    const specialChar = /^(?=.*[^A-Za-z0-9])/;
    const length = /^(?=.{8,})/;

    lowerCase.test(value)
      ? setPasswordVerification((prevState) => ({
          ...prevState,
          lowerCaseChecked: true,
        }))
      : setPasswordVerification((prevState) => ({
          ...prevState,
          lowerCaseChecked: false,
        }));
    upperCase.test(value)
      ? setPasswordVerification((prevState) => ({
          ...prevState,
          upperCaseChecked: true,
        }))
      : setPasswordVerification((prevState) => ({
          ...prevState,
          upperCaseChecked: false,
        }));
    number.test(value)
      ? setPasswordVerification((prevState) => ({
          ...prevState,
          numberChecked: true,
        }))
      : setPasswordVerification((prevState) => ({
          ...prevState,
          numberChecked: false,
        }));
    specialChar.test(value)
      ? setPasswordVerification((prevState) => ({
          ...prevState,
          specialCharChecked: true,
        }))
      : setPasswordVerification((prevState) => ({
          ...prevState,
          specialCharChecked: false,
        }));
    length.test(value)
      ? setPasswordVerification((prevState) => ({
          ...prevState,
          lengthChecked: true,
        }))
      : setPasswordVerification((prevState) => ({
          ...prevState,
          lengthChecked: false,
        }));
    setNewPassword(value);
    props.setUpdatedPassword(value);
  };

  const handleConfirmPassword = (value) => {
    setConfirmPassword(value);
  };

  const handleSetPasswordButton = () => {
    let verified =
      passwordVerification.lowerCaseChecked &&
      passwordVerification.upperCaseChecked &&
      passwordVerification.numberChecked &&
      passwordVerification.specialCharChecked &&
      passwordVerification.lengthChecked;
    if (confirmPassword.length && confirmPassword !== newPassword) {
      setPasswordMismatch(true);
      props.setIsSetPasswordDisabled(true);
    }
    if (confirmPassword.length && confirmPassword === newPassword) {
      setPasswordMismatch(false);
      verified && props.setIsSetPasswordDisabled(false);
    }
  };

  const showPasswordMismatch = (error) => (
    <Form.Text className="LoginCardErrorText">{i18n.t(error)}</Form.Text>
  );

  React.useEffect(() => {
    handleSetPasswordButton();
  }, [newPassword, confirmPassword, passwordVerification]);

  React.useEffect(() => {
    if (props.isError) {
      setNewPassword('');
      setConfirmPassword('');
      setPasswordMismatch(false);
      setPasswordVerification(initialValue);
    }
  }, [props.isError]);

  return (
    <>
      <Form.Label className="LoginCardFormLabel passwordLabel">
        {i18n.t('NEW_PASSWORD')}
      </Form.Label>
      <Form.Control
        type="password"
        value={newPassword}
        data-testid="newPassword"
        onChange={(e) => handleNewPassword(e.target.value)}
      />
      <div
        className={
          passwordVerification.lengthChecked ? 'checkPassed' : 'checkFailed'
        }
      >
        {passwordVerification.lengthChecked ? (
          <span className="iconSeparator">
            <Check />
          </span>
        ) : (
          <span className="iconSeparator">
            <Cross />
          </span>
        )}
        minimum 8 characters
      </div>
      <div
        className={
          passwordVerification.numberChecked ? 'checkPassed' : 'checkFailed'
        }
      >
        {passwordVerification.numberChecked ? (
          <span className="iconSeparator">
            <Check />
          </span>
        ) : (
          <span className="iconSeparator">
            <Cross />
          </span>
        )}
        must contain one number
      </div>
      <div
        className={
          passwordVerification.upperCaseChecked ? 'checkPassed' : 'checkFailed'
        }
      >
        {passwordVerification.upperCaseChecked ? (
          <span className="iconSeparator">
            <Check />
          </span>
        ) : (
          <span className="iconSeparator">
            <Cross />
          </span>
        )}
        must have one uppercase
      </div>
      <div
        className={
          passwordVerification.lowerCaseChecked ? 'checkPassed' : 'checkFailed'
        }
      >
        {passwordVerification.lowerCaseChecked ? (
          <span className="iconSeparator">
            <Check />
          </span>
        ) : (
          <span className="iconSeparator">
            <Cross />
          </span>
        )}
        must have one lowercase
      </div>
      <div
        className={
          passwordVerification.specialCharChecked
            ? 'checkPassed'
            : 'checkFailed'
        }
      >
        {passwordVerification.specialCharChecked ? (
          <span className="iconSeparator">
            <Check />
          </span>
        ) : (
          <span className="iconSeparator">
            <Cross />
          </span>
        )}
        must contain special character
      </div>
      <Form.Label className="LoginCardFormLabel passwordLabel">
        {i18n.t('CONFIRM_PASSWORD')}
      </Form.Label>
      <Form.Control
        type="password"
        value={confirmPassword}
        data-testid="confirmPassword"
        onChange={(e) => handleConfirmPassword(e.target.value)}
      />
      {passwordMismatch && showPasswordMismatch('PASSWORD_DOES_NOT_MATCH')}
      <div className="setButton">
        <Button
          variant="primary"
          disabled={props.isDisabled}
          block={true}
          onClick={props.handleSubmit}
        >
          {props.isLoading ? (
            <Spinner
              accessibilityLabel="Loading"
              className="uxf-spinner-border-sm"
              animation="border"
            />
          ) : (
            <>{props.buttonText}</>
          )}
        </Button>
      </div>
    </>
  );
};

export default VerifyPassword;
